import React from 'react';
import { Chip } from '@mui/material';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

const UsageInfoFormatter = ({ row }) => {
  return (
    <>
      {row.usage_info && row.usage_info.includes('\n') ? (
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {row.usage_info.split(/\r?\n/).filter(Boolean).map((info, i) => (
            <li key={i} style={{ color: '#222', fontSize: 15 }}>{info.trim()}</li>
          ))}
        </ul>
      ) : (
        row.usage_info
      )}      
    </>
  );
};
const UsageInfoTypeProvider = props => <DataTypeProvider formatterComponent={UsageInfoFormatter} {...props} />

export default UsageInfoTypeProvider;
